var _classCallCheck = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/createClass");

var utils = require('../utils');

function trim(str) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}

function getCookie(cookieName, cookieString) {
  cookieString = cookieString || window.document.cookie;

  if (cookieString && cookieString !== '') {
    var cookies = cookieString.split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = trim(cookies[i]); // Does this cookie string begin with the name we want?

      if (cookie.substring(0, cookieName.length + 1) === cookieName + '=') {
        return decodeURIComponent(cookie.substring(cookieName.length + 1));
      }
    }
  }

  return null;
}

var SessionAuthentication =
/*#__PURE__*/
function () {
  "use strict";

  function SessionAuthentication() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SessionAuthentication);

    this.csrfToken = getCookie(options.csrfCookieName, options.cookieString);
    this.csrfHeaderName = options.csrfHeaderName;
  }

  _createClass(SessionAuthentication, [{
    key: "authenticate",
    value: function authenticate(options) {
      options.credentials = 'same-origin';

      if (this.csrfToken && !utils.csrfSafeMethod(options.method)) {
        options.headers[this.csrfHeaderName] = this.csrfToken;
      }

      return options;
    }
  }]);

  return SessionAuthentication;
}();

module.exports = {
  SessionAuthentication: SessionAuthentication
};